<template>
    <div class="technology">
        <div class="banner">
            <div class="left">
                <img src="@/assets/contact/banner-text.png"/>
                <div class="text">
                    Ready to take your construction projects to the next level? Reach out to us today.
                </div>
            </div>
            <div class="right">
                <div class="form">
                    <div class="form-column">
                        <div class="column">
                            <div class="input-box">
                                <div class="label">Name</div>
                                <div class="input">
                                    <el-input type="text" v-model="name" placeholder="Your Name"/>
                                </div>
                            </div>

                            <div class="input-box">
                                <div class="label">Email</div>
                                <div class="input">
                                    <el-input type="text" v-model="email" placeholder="Your Email"/>
                                </div>
                            </div>
                        </div>

                        <div class="column">
                            <div class="input-box">
                                <div class="label">Phone number</div>
                                <div class="input">
                                    <el-input type="text" v-model="number" placeholder="Your Phone Number"/>
                                </div>
                            </div>
                        </div>

                        <div class="column">
                            <div class="input-area-box">
                                <div class="label">Message</div>
                                <div class="input">
                                    <el-input type="textarea" v-model="message" rows="3" placeholder="Leave A Message" style="height: 120px" resize="none"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-button" @click="visible = true">Submit</div>
                </div>
            </div>
        </div>

        <success :dialog-visible.sync="visible"/>
    </div>
</template>

<script>
import success from './Success';

export default {
    components: {
        success
    },
    data: () => ({
        name: "",
        email: "",
        number: "",
        message: "",
        visible: false
    })
}
</script>

<style scoped lang="scss">
.technology {
    flex: 1;
}
.banner {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    width: 100%;
    height: 694px;
    background: url("../assets/contact/banner.png") no-repeat 100%;
    background-size: contain;

    padding: 178px 110px 0px 138px;

    .left {
        width: 538px;
        padding-top: 10px;

        > img {
            width: 100%;
            object-fit: contain;
            margin-bottom: 22px;
        }

        .text {
            padding-right: 10px;
            font-size: 16px;
            color: #ffffff;
            line-height: 30px;
        }
    }

    .right {
        width: 543px;

        .form {
            width: 100%;
            padding-right: 7px;

            .form-column {
                width: 100%;
                height: 248px;
                margin-bottom: 24px;
            }

            .form-button {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 120px;
                height: 40px;
                font-size: 16px;
                color: #ffffff;
                border: 1px solid rgb(127, 127, 127);
                border-radius: 20px;
                margin-bottom: 94px;
                cursor: pointer;
            }

            .column {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 24px;
                gap: 24px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .input-box,
            .input-area-box {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                border: 1px solid rgb(127, 127, 127);
                border-radius: 8px;

                .label {
                    flex: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 40px;
                    font-size: 14px;
                    color: #ffffff;
                    padding: 0 20px;
                }

                .input {
                    flex: 1;

                    /deep/ .el-input__inner,
                    /deep/ .el-textarea__inner {
                        background-color: transparent;
                        border: 0;
                        color: #ffffff;
                        line-height: 40px;

                        &::placeholder {
                            color: rgb(110, 110, 110);
                        }
                    }

                    /deep/ .el-textarea__inner {
                        padding-top: 0;
                        padding-bottom: 0;
                    }
                }
            }

            .input-area-box {
                align-items: flex-start;
            }
        }

        .bottom-text {
            font-size: 12px;
            color: #5b6375;
            line-height: 22px;
        }
    }
}
</style>